import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  PERMISSION_PRODUCTIONS_WRITE
} from '../../constants'
import StatusBadge from '../common/helpers/StatusBadge'
import ActivateOrEditProductionPopup from './helpers/ActivateOrEditProductionPopup'
import ConfirmRequestPopup from '../common/helpers/ConfirmRequestPopup'
import ImageInCoverStyle from '../common/helpers/ImageInCoverStyle'
import { clearProduction } from '../../actions/pages/production-page'
import PieChartPanel from '../common/statistics/PieChartPanel'
import AreaChartPanel from '../common/statistics/AreaChartPanel'
import ProtectedElement from '../common/helpers/ProtectedElement'

class ProductionOverview extends Component {
  render() {
    if (this.props.overview === null) {
      return (<div />)
    }
    let overviewData = this.props.overview;

    let status = (<StatusBadge status={overviewData.Status.toLowerCase()} statusLabel={overviewData.Status} />)

    let manageBtn = (
      <ProtectedElement permission={PERMISSION_PRODUCTIONS_WRITE}>
        <div className="row">
          <div className="col-6"></div>
          <div className="col-6 text-right">
            <ActivateOrEditProductionPopup productionId={this.props.productionId} />
            {this.props.overview.Status === 'Active' && this.props.overview.AreDraftOrActiveVacancies === false &&
              <ConfirmRequestPopup
                url={'productions/' + this.props.productionId + '/finish'}
                btnLabel="Finish"
                successMessage="The production was finished."
                onSuccess={() => { this.props.clearProduction() }} />
            }
            {this.props.overview.Status === 'Finished' &&
              <ConfirmRequestPopup
                url={'productions/' + this.props.productionId + '/reopen'}
                btnLabel="Reopen"
                successMessage="The production was re-opened."
                onSuccess={() => { this.props.clearProduction() }} />
            }
          </div>
        </div>
        </ProtectedElement>
    )

    return (
      <div>
        {manageBtn}
        <div className="row">
          <div className="col-md-6 widget">
            <div className="title">Overview</div>
            <div className="row">
              <div className="col-4">
                <ImageInCoverStyle imageUrl={overviewData.PosterUrl} width="150px" height="200px" />
              </div>
              <div className="col-8">
                <div className="col">
                  <div className="row">
                    <div className="col-5">Project number:</div>
                    <div className="col-7">{overviewData.ProjectNumber}</div>
                  </div>
                  <div className="row">
                    <div className="col-5">Client:</div>
                    <div className="col-7">{overviewData.ClientName}</div>
                  </div>
                  <div className="row">
                    <div className="col-5">Original title:</div>
                    <div className="col-7">{overviewData.OriginalTitle}</div>
                  </div>
                  <div className="row">
                    <div className="col-5">Original language:</div>
                    <div className="col-7">{overviewData.OriginalLanguage}</div>
                  </div>
                  <div className="row">
                    <div className="col-5">Local title:</div>
                    <div className="col-7">{overviewData.LocalizedTitle}</div>
                  </div>
                  <div className="row">
                    <div className="col-5">Runtime:</div>
                    <div className="col-7">{overviewData.RunTimes}</div>
                  </div>
                  <div className="row">
                    <div className="col-5">TMDb reference:</div>
                    <div className="col-7"><a href={overviewData.TmdbWebUrl}>{overviewData.TmdbKey}</a></div>
                  </div>
                  <div className="row">
                    <div className="col-5">Urgent:</div>
                    <div className="col-7">{overviewData.Urgent ? 'Yes' : 'No'}</div>
                  </div>
                  <div className="row">
                    <div className="col-5">Status:</div>
                    <div className="col-7">{status}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="title">Plot summary</div>
            <div className="row">
              <div className="col-12 plot-summary">{overviewData.Description}</div>
            </div>
          </div>
          <div className="col-md-6 widget">
            <div>
              <PieChartPanel title="Offers" data={overviewData.StatisticsOfOffers} colors={["blue", "green", "purple", "indigo"]} />
            </div>
            <div>
              <PieChartPanel title="Candidates" data={overviewData.StatisticsOfCandidates} colors={["blue", "darkblue", "green", "indigo", "purple", "teal", "cyan"]} />
            </div>
            <div>
              <AreaChartPanel title="Views" data={overviewData.StatisticsOfViews} />
            </div>
          </div>
        </div>
        {manageBtn}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  overview: state.productionPage.overview
})
const mapDispatchToProps = dispatch => ({
  clearProduction() { dispatch(clearProduction()) }
})
export default connect(mapStateToProps, mapDispatchToProps)(ProductionOverview)
